// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_PreflightLaudosInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de GET /migration/laudos/preflight?zoho_id_unidade=
 * (controllers/migration/laudos.php::preflight).
 *
 * So a franquia: a E7 nao tem date range (decisao 46) — o recorte da carga e
 * o PERTENCIMENTO (o item da E6 diz de qual franquia cada foto e).
 *
 * Tipo ESTRITO pelo motivo de sempre: o id da unidade tem 19 digitos e e
 * MAIOR que 2^53 — um numero JSON aqui ja chegaria corrompido (armadilha A1).
 */
import { registerContract } from './validate'

export interface Migration_PreflightLaudosInput {
zoho_id_unidade?: string
data_ini?: string
data_fim?: string
ids?: string
}

registerContract('Migration_PreflightLaudosInput', {
  zoho_id_unidade: { type: 'string',  required: false },
  data_ini:        { type: 'string',  required: false },
  data_fim:        { type: 'string',  required: false },
  ids:             { type: 'string',  required: false },
})
